import { api } from "./client";
import { commitOptions } from "./commitSeams";

export interface WorkspaceAdoptionCandidate {
  person_id: string;
  role: "student" | "instructor";
  workspace_user_id: string;
  reviewed_email: string;
  reviewed_given_name: string;
  reviewed_family_name: string;
  intake_receipt_id: string;
}
export interface WorkspaceAdoptionCandidates {
  enabled: boolean;
  transfer_identified: boolean;
  unavailable_reason?: string;
  candidates: WorkspaceAdoptionCandidate[];
}
export interface WorkspaceAdoptionResult {
  id: string;
  person_id: string;
  role: "student" | "instructor";
  workspace_user_id: string;
  user_id: string;
  intake_receipt_id: string;
  completed_at: string | null;
  valid_after: string | null;
}
export interface WorkspaceAdoptionStatus {
  state: "not_committed" | "pending" | "confirmed";
  result?: WorkspaceAdoptionResult;
}
const base = "/accounts/existing-workspace-adoptions";
const personBase = (personId: string) => `/accounts/people/${encodeURIComponent(personId)}/existing-workspace-adoptions`;
export const workspaceAdoptionApi = {
  candidates: (personId: string) => api.get<WorkspaceAdoptionCandidates>(`${personBase(personId)}/candidates`),
  adopt: (body: WorkspaceAdoptionCandidate, key: string) => api.post<WorkspaceAdoptionResult>(base, body, commitOptions(key)),
  status: (personId: string, key: string) => api.get<WorkspaceAdoptionStatus>(`${personBase(personId)}/${encodeURIComponent(key)}`),
};
